// Copyright (c) 2025 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { Badge } from '@loa/ui-components';
import { LOAStatus } from '../types/loa';

type BadgeColor = 'grey' | 'orange' | 'yellow' | 'green' | 'red' | 'blue' | 'teal' | 'neutral' | 'purple';

interface LOAStatusBadgeProps {
  status: LOAStatus;
}

const statusConfig: Record<LOAStatus, { color: BadgeColor; text: string }> = {
  [LOAStatus.DRAFT]: { color: 'grey', text: 'Draft' },
  [LOAStatus.GENERATING]: { color: 'blue', text: 'Generating' },
  [LOAStatus.PENDING_SIGNATURE]: { color: 'yellow', text: 'Pending Signature' },
  [LOAStatus.PARTIALLY_SIGNED]: { color: 'orange', text: 'Partially Signed' },
  [LOAStatus.COMPLETED]: { color: 'green', text: 'Completed' },
  [LOAStatus.DECLINED]: { color: 'red', text: 'Declined' },
  [LOAStatus.FAILED]: { color: 'red', text: 'Failed' },
  [LOAStatus.EXPIRED]: { color: 'grey', text: 'Expired' },
  [LOAStatus.VOIDED]: { color: 'neutral', text: 'Voided' }
};

export const LOAStatusBadge: React.FC<LOAStatusBadgeProps> = ({ status }) => {
  const config = statusConfig[status];

  return (
    <Badge color={config.color} size="sm">
      {config.text}
    </Badge>
  );
};
